import { render, staticRenderFns } from "./Bimobjects.vue?vue&type=template&id=7a965f3a&"
import script from "./Bimobjects.vue?vue&type=script&lang=js&"
export * from "./Bimobjects.vue?vue&type=script&lang=js&"
import style0 from "./Bimobjects.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports